import Button from '../Buttons/Index';

const Index = (props) => {
  return (
    <div
      className="relative z-10"
      aria-labelledby="modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity"></div>

      <div className="fixed inset-0 z-10 overflow-y-auto">
        <div className="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0">
          <div className="relative transform overflow-hidden bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
            <div className="sm:flex sm:items-start">
              <div className="mt-1 mb-0 pt-2 px-5 text-center sm:mt-0 sm:ml-0">
                <h1
                  className="text-lg font-medium leading-6 text-gray-900"
                  id="modal-title"
                >
                  {props.title}
                </h1>
              </div>
            </div>
            <div className="relative flex py-2 items-center">
              <div className="flex-grow border-t border-orange-600 border-2"></div>
            </div>
            <div className="bg-white px-0 pt-0 pb-4 sm:p-5 sm:pt-2 sm:pb-4">
              <div className="mt-0 p-px">{props.children}</div>
            </div>
            <div className="btn-group bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6 space-y-2 sm:space-y-0 sm:space-x-3 sm:space-x-reverse">
              {props.enter && (
                <Button
                  className="w-full text-sm px-3 py-1.5 whitespace-nowrap"
                  onClick={props.enter}
                  disabled={props.loading}
                >
                  {props.loading ? 'Please Wait...' : props.btnLabel}
                </Button>
              )}
              {props.decline && (
                <Button
                  variant="danger"
                  className="w-full text-sm px-3 py-1.5 whitespace-nowrap"
                  onClick={props.decline}
                  disabled={props.loading}
                >
                  {props.loading
                    ? 'Please Wait...'
                    : props.btnDeclineLabel || 'Decline Payment'}
                </Button>
              )}
              <Button
                variant="default"
                className="w-full text-sm px-3 py-1.5 whitespace-nowrap"
                onClick={props.cancel}
                disabled={props.loading}
              >
                Cancel
              </Button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Index;
